var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogomasterbets365 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFCE00;}\r\n\t.st2{fill:#000D30;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M442.7,860.9h-1.9v22.9h2c4.6,0,6.5-1.5,6.5-8.8v-6.3C449.3,862.7,448,860.9,442.7,860.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.8,863.1c-0.3,5.5-1.9,29-2.6,39.3h6.7c-0.7-8.9-2.5-32.8-3.1-39.3H177.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M511.9,898.2h-1.8v27.7h2.6c4.8,0,5.8-2.6,5.8-8.3v-11.2C518.6,900.4,517.1,898.2,511.9,898.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M518.6,874.5v-6.3c0-4.4-1-7.3-5.8-7.3h-2.7v20.7h2.9C516.9,881.6,518.6,879.8,518.6,874.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M845.9,893.3c-2.6,0-4.3,1.5-4.3,7.5v16c0,4.7,1.1,7.3,4.2,7.3c2.7,0,4.2-2.3,4.2-7.4v-16.3 C850.1,895.2,848.8,893.3,845.9,893.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "549,507.7 608.3,468.4 608.3,400.2 549,400.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M773.4,298.1V155.1h-6.3c-51.5,0-93.2-43.3-93.2-94.8v-4.7H271.4v4.7c0,51.5-41.7,94.8-93.2,94.8h-6.3v143.1 c0,160,80.3,308.5,213.4,397.2l87.5,57.8l87.4-57.8C693.2,606.6,773.4,458.1,773.4,298.1z M590.1,127.1l6.2-19.2l6.2,19.2h20.2 l-16.3,10.8l6.2,18.9l-16.3-12.3l-16.3,11.6l6.2-18L570,127.1H590.1z M527.6,127.1l6.2-19.2l6.2,19.2h20.2l-16.3,10.8l6.2,18.9 l-16.3-12.3l-16.3,11.6l6.2-18l-16.3-10.9H527.6z M402.4,127.1l6.2-19.2l6.2,19.2h20.2l-16.3,10.8l6.2,18.9l-16.3-12.3l-16.3,11.6 l6.2-18l-16.3-10.9H402.4z M339.9,127.1l6.2-19.2l6.2,19.2h20.2l-16.3,10.8l6.2,18.9l-16.3-12.3l-16.3,11.6l6.2-18l-16.3-10.9 H339.9z M455.1,674.4l-61.9-39.8V282.3l-29.6,43.5L333,281v272.2l-41.1-26.6c0,0-24.3-15.7-19.8-61.6V188.9h61.2l29.9,42.5 l31.2-42.5h60.7V674.4z M471.2,144.5l-16.3,11.6l6.2-18l-16.3-10.9H465l6.2-19.2l6.2,19.2h20.2l-16.3,10.8l6.2,18.9L471.2,144.5z  M488.7,188H670v148.9l-18.6,22.9l19.6,24.1v87.5c0,0,0,56.6-36.2,86.4l-146,117.5V188z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549,
    y: 264.4,
    className: "st1",
    width: 59.3,
    height: 61.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "329.8,156.1 346.1,144.5 362.4,156.8 356.2,137.9 372.5,127.1 352.3,127.1 346.1,108 339.9,127.1  319.7,127.1 336,138.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "392.4,156.1 408.7,144.5 425,156.8 418.8,137.9 435.1,127.1 414.9,127.1 408.7,108 402.4,127.1  382.3,127.1 398.6,138.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "497.6,127.1 477.5,127.1 471.2,108 465,127.1 444.9,127.1 461.2,138.1 454.9,156.1 471.2,144.5  487.6,156.8 481.3,137.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "517.5,156.1 533.8,144.5 550.1,156.8 543.9,137.9 560.2,127.1 540,127.1 533.8,108 527.6,127.1  507.4,127.1 523.7,138.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "580.1,156.1 596.4,144.5 612.7,156.8 606.5,137.9 622.8,127.1 602.6,127.1 596.4,108 590.1,127.1  570,127.1 586.3,138.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M363.2,231.4l-29.9-42.5h-61.2v276.2c-4.6,45.9,19.8,61.6,19.8,61.6l41.1,26.6V281l30.6,44.7l29.6-43.5v352.3 l61.9,39.8V188.9h-60.7L363.2,231.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M671,471.5v-87.5l-19.6-24.1l18.6-22.9V188H488.7v487.4l146-117.5C671,528,671,471.5,671,471.5z M608.3,468.4 L549,507.7V400.2h59.3V468.4z M608.3,326H549v-61.6h59.3V326z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.3,890.9h-0.8c-0.8-12.3-3.3-35.5-4.7-47.2H59.2v99.2h20.9v-26.4c0-17.1-0.6-37.3-0.8-49h1 c1.9,19.2,5.3,58.9,6.5,75.4h17.4c1-10.8,4.6-51.7,6.5-75h1c-0.2,13-0.3,35.2-0.3,49v26h22.5v-99.2h-32.6 C99,864.3,97.7,876.6,96.3,890.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.7,843.7l-11.8,99.2h23.5l1.5-21.1h9.2l1.6,21.1h23.9l-11.9-99.2H160.7z M175.2,902.4 c0.7-10.3,2.4-33.8,2.6-39.3h1c0.6,6.6,2.4,30.4,3.1,39.3H175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.4,880.8c-7.9-6.5-8.9-8.8-8.9-14.1c0-4.7,1.1-6.6,3.4-6.6c2.8,0,3.7,1.9,3.7,7.6v6.4h20.9v-5.3 c0-13.5-4.1-26.6-25.2-26.6c-19.4,0-25.6,12.3-25.6,28.1c0,14.5,5.8,20.5,18.2,31.2c9.5,8.2,10.8,10.7,10.8,18.3 c0,4-0.9,6.7-3.7,6.7c-2.9,0-4.1-2.1-4.1-8.5v-6.9h-22.2v5.3c0,17.3,6.9,28,26.4,28c21,0,26.9-11.9,26.9-29.5 C277.1,899.1,270.8,892.6,256.4,880.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "292.1,862.9 305.1,862.9 305.1,942.9 328.1,942.9 328.1,862.9 341.1,862.9 341.1,843.7 292.1,843.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "379.2,900.4 399,900.4 399,881.3 379.2,881.3 379.2,862.9 400,862.9 400,843.7 356.1,843.7  356.1,942.9 400.1,942.9 402.7,923.8 379.2,923.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M446.9,843.7h-29.2v99.2h23v-41.8h1.6c5.4,0,6.5,1.1,6.5,11.2v0.4c0,19.2,0.2,27.8,1.3,30.2h22.5 c-0.5-4.1-0.4-15.9-0.4-27.1v-0.3c0-14.2-2.3-19.6-9.4-22.9c5.7-2.8,10-8.2,10-20.3v-3.2C472.6,853,465.8,843.7,446.9,843.7z  M449.3,875.1c0,7.3-1.9,8.8-6.5,8.8h-2v-22.9h1.9c5.3,0,6.6,1.8,6.6,7.8V875.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M530.6,889.6c5.6-1.9,10.6-6.5,10.6-19v-4.1c0-16.2-10-22.7-26-22.7h-27.6v99.2h28.1c19.4,0,27-8.2,27-26.8 v-7.4C542.8,896,536,891.7,530.6,889.6z M510.2,860.9h2.7c4.8,0,5.8,2.9,5.8,7.3v6.3c0,5.3-1.7,7.1-5.5,7.1h-2.9V860.9z  M518.6,917.7c0,5.7-1.1,8.3-5.8,8.3h-2.6v-27.7h1.8c5.2,0,6.7,2.2,6.7,8.2V917.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "580.8,900.4 600.6,900.4 600.6,881.3 580.8,881.3 580.8,862.9 601.6,862.9 601.6,843.7 557.8,843.7  557.8,942.9 601.7,942.9 604.3,923.8 580.8,923.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "619.3,862.9 632.3,862.9 632.3,942.9 655.4,942.9 655.4,862.9 668.4,862.9 668.4,843.7 619.3,843.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M716.1,880.8c-7.9-6.5-8.9-8.8-8.9-14.1c0-4.7,1.1-6.6,3.4-6.6c2.8,0,3.7,1.9,3.7,7.6v6.4h20.9v-5.3 c0-13.5-4.1-26.6-25.2-26.6c-19.4,0-25.6,12.3-25.6,28.1c0,14.5,5.8,20.5,18.2,31.2c9.5,8.2,10.8,10.7,10.8,18.3 c0,4-0.9,6.7-3.7,6.7c-2.9,0-4.1-2.1-4.1-8.5v-6.9h-22.2v5.3c0,17.3,6.9,28,26.4,28c21,0,26.9-11.9,26.9-29.5 C736.7,899.1,730.5,892.6,716.1,880.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M791.9,888v-0.3c5.5-2.1,10.6-7,10.6-18.6V865c0-15.1-8.5-22.9-25-22.9c-20.6,0-24.8,12.8-24.9,24.5v4.8h20.4 v-5.8c0-4.2,0.7-7.1,4.1-7.1c3.1,0,3.8,2.6,3.8,6.9v5.9c0,7.4-2.6,8.4-7.8,8.4h-7.4v17.4h6.6c7.1,0,9,2.4,9,10.2v9.3 c0,4-0.9,7.4-4.1,7.4c-3.3,0-4.4-2.7-4.4-7.6v-4.9h-21v3.8c0,13.2,5,25.9,25.4,25.9c19.3,0,27-9.3,27-26.7v-6.9 C804.2,895.1,797.3,890,791.9,888z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M855.4,874.8c-4.9,0-10.1,1.5-13.7,6.2v-12.3c0-5.9,0.8-9,4.2-9c3.2,0,4.2,2.3,4.2,6.9v1.7h21.3v-1.1 c0-9.2-2.6-25.1-25.4-25.1c-20.2,0-26.8,12.7-26.8,31.2v39.4c0,18.2,8,28.6,26.7,28.6c18.6,0,26.9-10.7,26.9-27.3v-16.3 C872.9,885.2,868.6,874.8,855.4,874.8z M850.1,916.7c0,5.1-1.5,7.4-4.2,7.4c-3.1,0-4.2-2.6-4.2-7.3v-16c0-5.9,1.6-7.5,4.3-7.5 c2.9,0,4.2,1.9,4.2,7.2V916.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M923.7,874.1c-4.3,0-9.8,1.5-11.9,4.7c0.3-4.3,0.8-11.4,1-15.8h23.5l2.4-19.3h-46.1c-1,18.3-2.4,41.2-3.9,56.1 l20.8,1.3c0.1-6.9,1.6-8.6,4.2-8.6c2.6,0,3.8,1.5,3.8,7.4v16c0,5.6-1,8.1-4,8.1c-3.2,0-4-3-4-7v-5.9h-21.7v3 c0,12.2,3.3,26.9,26.4,26.9c21.7,0,26.6-14.5,26.6-30.5v-13.2C940.8,883.4,936.4,874.1,923.7,874.1z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogomasterbets365);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LOGOMASTERBETS365.fa7da5d10f26f77a1ad80f0f83a846d0.svg";